import React, { useContext, useEffect } from 'react'
import { authContext } from '../../Login/AuthContext';

var areas = [];

const AreasTable = () => {
  const { auth } = useContext(authContext);

  useEffect(() => {
    if(auth.data){
      fetch("https://mel.dvrc.fr/api/GetGadmDataFromShapeGID36.php?shape_gid="+auth.data.zone.shapes+"&token="+auth.data.token)
        .then(res => res.json())
        .then( (data) => {
          areas = data;
      })
    }
    }, [auth.data])

  if(!auth.data.zone)
    return;
  return (
    <div className="container" key="areas_container">
         <div className="alert alert-primary" role="alert" key="areas_clickingBar"><b>Communes</b> de "<i>{auth.data.zone.name}</i>" <a href="#areas" onClick={() => {showAreaTable();}}>({auth.data.zone.shapes.split(",").length} communes)</a></div>
         <div className="col" id="areas_data">
           <table className="table" key="testOther">
            {showHeaders()}
            {showAreas()}
           </table>
         </div>
     </div>
  )}

export default AreasTable;

function  showAreaTable (status=global.statusAreas){
      global.statusAreas = !status;
      if(global.statusAreas)
        document.getElementById("areas_data").style.display = "block";
      else {
        document.getElementById("areas_data").style.display = "none";
      }
  }

/*
export function getAreas(shapeGID, token){
    fetch("https://mel.dvrc.fr/api/GetGadmDataFromShapeGID36.php?shape_gid="+shapeGID+"&token="+token)
      .then(res => res.json())
      .then( (data) => {
        var itemNames=Object.keys(data[0]);

        var headTab='<table class="table" id="testOther"><thead>';
        var dataTab="";

        for(var i in itemNames){headTab+='<th>'+itemNames[i]+'</th>';}
        headTab+='</thead>';

        for(var j in data)
        {
            var itemValues=Object.values(data[j]);
            dataTab+='<tr class="parent" id="' + i + '">';
            for(i in itemValues)dataTab+='<td>'+itemValues[i]+'</td>';
            dataTab+='</tr>';
        }
        var output=headTab+dataTab;
        document.getElementById("dataGADM").innerHTML = output;
    }).catch(console.log);
}*/

function showHeaders (){
  if(areas.length === 0)
    return ;
  return (
      <thead>
        <tr className="parent" key={"area_headers"}>
          {
            Object.keys(areas[0]).map((td, key) => {
              return (
                <th key={"area_headers_"+key}>{td}</th>
              )
            })
          }
        </tr>
      </thead>
  )
}

function showAreas (){
  if(areas.length === 0)
    return ;
  return (
      <tbody>{
        areas.map((area,i) => {
            return (
              <tr  className="parent" key={"area_"+i}>
                {
                  Object.keys(area).map((td, key) => {
                    return (
                      <td key={"area_"+i+"_"+key}>{area[td]}</td>
                    )
                  })
                }
              </tr>
            )
        })}
      </tbody>
  )
}
